import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Box } from '@mui/material';

import StandardDataGrid from '../../../components/Common/StandardDataGrid';
import NewsModal from '../../../components/DataSections/News/Modal/NewsModal';
import { NewsArticleModel } from '../../../models/data-sections/news/articleModel';
import { trimDate } from '../../../utils/commonUtils';

interface NewsProps {
  searchExecutionId: string;
  articles: NewsArticleModel[] | null;
  isLoading: boolean;
}

const News: React.FC<NewsProps> = ({ searchExecutionId, articles, isLoading }) => {
  const columns: GridColDef<NewsArticleModel>[] = [
    { field: 'title', headerName: 'Title', width: 400 },
    { field: 'source', headerName: 'Source', width: 150 },
    {
      field: 'authors',
      headerName: 'Authors',
      width: 250,
      renderCell: (params) => (
        <Box sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.value?.join(', ') || 'N/A'}
        </Box>
      ),
    },
    {
      field: 'overall_sentiment_label',
      headerName: 'Sentiment',
      width: 130,
    },
    {
      field: 'overall_sentiment_score',
      headerName: 'Score',
      width: 100,
      type: 'number',
      valueFormatter: ({ value }) => (value as number)?.toFixed(2),
    },
    {
      field: 'time_published',
      headerName: 'Published',
      width: 180,
      renderCell: (params) => <>{trimDate(params.value as string)}</>,
    },
  ];

  const rows = articles?.map((article, index) => ({
    id: index,
    ...article,
  })) || [];

  return (
    <StandardDataGrid
      isLoading={isLoading}
      singleGrid={{
        rows,
        columns,
        modalRenderer: (row) => (
          <NewsModal
            searchExecutionId={searchExecutionId}
            selected_article={row}
            onClose={() => {}}
          />
        ),
      }}
    />
  );
};

export default News;
